<template>
  <div class="about-container">
    <StaticPagesHeader class="header"></StaticPagesHeader>
    <div class="container">
      <h1 class="title">{{ $t(`about.title`) }}</h1>

      <section
        class="app-content"
        :style="{ backgroundImage: originBackground }"
      >
        <h2 class="subtitle">{{ $t(`about.contentSection.title`) }}</h2>
        <StyledParagraph title="" v-bind:paragraphs="contentSection" />
      </section>

      <section class="styled-content">
        <h2 class="subtitle">{{ $t(`about.forWhoSection.title`) }}</h2>
        <p>
          {{ $t(`about.forWhoSection.paragraphs[0]`) }}
        </p>
      </section>
      <section
        class="app-content"
        :style="{ backgroundImage: originBackground }"
      >
        <h2 class="subtitle">{{ $t(`about.HowDoesItWorkSection.title`) }}</h2>
        <div class="row">
          <div class="col-md-8">
            <DecoratedSubtitle
              v-bind:title="
                $t(`about.HowDoesItWorkSection.forIndividuals.title`)
              "
            />
          </div>
          <div class="col-md-4 icon">
            <img :src="teacherIcon" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <img
              class="image img-responsive"
              :src="studentScreen[$i18n.locale]"
            />
          </div>
          <div class="col-md-6 side-text">
            {{ $t(`about.HowDoesItWorkSection.forIndividuals.paragraphs[0]`) }}
          </div>
        </div>
        <div class="row flex-row-reverse">
          <div class="col-md-6">
            <img
              class="image img-responsive"
              :src="exerciceScreen[$i18n.locale]"
            />
          </div>
          <div class="col-md-6 side-text">
            {{ $t(`about.HowDoesItWorkSection.forIndividuals.paragraphs[1]`) }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <img
              class="image img-responsive"
              :src="paymentScreen[$i18n.locale]"
            />
          </div>
          <div class="col-md-6 side-text">
            {{ $t(`about.HowDoesItWorkSection.forIndividuals.paragraphs[2]`) }}
            <br />

            {{ $t(`about.HowDoesItWorkSection.forIndividuals.paragraphs[3]`) }}
          </div>
        </div>
      </section>
      <section
        class="styled-content"
        :style="{ backgroundImage: patternIizenglish }"
      >
        <div class="row">
          <div class="col-md-4 icon">
            <img :src="studentIcon" />
          </div>
          <div class="col-md-8">
            <DecoratedSubtitle
              v-bind:title="$t(`about.HowDoesItWorkSection.forTeachers.title`)"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <img
              class="image img-responsive"
              :src="teacherScreen[$i18n.locale]"
            />
          </div>
          <div class="col-md-6 side-text">
            {{ $t(`about.HowDoesItWorkSection.forTeachers.paragraphs[0]`) }}
          </div>
        </div>
        <div class="row flex-row-reverse">
          <div class="col-md-6">
            <img
              class="image img-responsive"
              :src="teacherDashboardScreen[$i18n.locale]"
            />
          </div>
          <div class="col-md-6 side-text">
            {{ $t(`about.HowDoesItWorkSection.forTeachers.paragraphs[1]`) }}
          </div>
        </div>
        <div class="row side-text">
          {{ $t(`about.HowDoesItWorkSection.forTeachers.paragraphs[2]`) }}
        </div>
        <div class="row side-text">
          {{ $t(`about.HowDoesItWorkSection.forTeachers.paragraphs[3]`) }}
        </div>
        <div class="row side-text">
          {{ $t(`about.HowDoesItWorkSection.forTeachers.paragraphs[4]`) }}
        </div>
      </section>
      <section>
        <div class="row">
          <div class="col-md-6">
            <DecoratedSubtitle
              v-bind:title="
                $t(
                  `about.HowDoesItWorkSection.forStudentsAttachedToTeacher.title`,
                )
              "
            />
          </div>
        </div>
        <p>
          {{
            $t(
              `about.HowDoesItWorkSection.forStudentsAttachedToTeacher.paragraphs[0]`,
            )
          }}
        </p>
        <p>
          {{
            $t(
              `about.HowDoesItWorkSection.forStudentsAttachedToTeacher.paragraphs[1]`,
            )
          }}
        </p>
        <p>
          {{
            $t(
              `about.HowDoesItWorkSection.forStudentsAttachedToTeacher.paragraphs[2]`,
            )
          }}
        </p>
        <p>
          {{
            $t(
              `about.HowDoesItWorkSection.forStudentsAttachedToTeacher.paragraphs[3]`,
            )
          }}
        </p>
      </section>
      <section
        class="styled-content"
        :style="{ backgroundImage: patternIizenglish }"
      >
        <h2 class="subtitle">{{ $t(`about.AndNowSection.title`) }}</h2>
        <p>
          {{ $t(`about.AndNowSection.paragraphs[0]`) }}
        </p>
        <p>
          {{ $t(`about.AndNowSection.paragraphs[1]`) }}
        </p>
        <p>
          {{ $t(`about.AndNowSection.paragraphs[2]`, { price: price }) }}
        </p>
        <router-link :to="{ name: 'SignUp' }" class="pill">{{
          $t(`about.AndNowSection.links[0]`)
        }}</router-link>
        <p>
          {{ $t(`about.AndNowSection.paragraphs[3]`) }}
        </p>
        <router-link :to="{ name: 'SignUp' }" class="pill">{{
          $t(`about.AndNowSection.links[1]`)
        }}</router-link>
      </section>
    </div>
    <section
      class="bottom-section"
      :style="{ backgroundImage: bottomBackground }"
    >
      <div class="content">
        <h3 class="section-title">
          {{ $t(`about.bottomSection.title`) }}
        </h3>
        <p>
          {{ $t(`about.bottomSection.paragraphs[0]`) }}
        </p>
        <p>
          {{ $t(`about.bottomSection.paragraphs[1]`) }}
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import FormePlaneteIizenglishRose from "@/assets/homepage/forme-planete-iizenglish-rose.webp";
import StudentInscriptionFr from "@/assets/about/fr/student-inscription.webp";
import StudentInscriptionEn from "@/assets/about/en/student-inscription.webp";
import StudentExercicesFr from "@/assets/about/fr/student-exercices.webp";
import StudentExercicesEn from "@/assets/about/en/student-exercices.webp";
import SubscribeFr from "@/assets/about/fr/subscribe.webp";
import SubscribeEn from "@/assets/about/en/subscribe.webp";
import TeacherInscriptionFr from "@/assets/about/fr/teacher-inscription.webp";
import TeacherInscriptionEn from "@/assets/about/en/teacher-inscription.webp";
import TeacherSpaceFr from "@/assets/about/fr/teacher-space.webp";
import TeacherSpaceEn from "@/assets/about/en/teacher-space.webp";
import StudentIcon from "@/assets/homepage/eleve.webp";
import TeacherIcon from "@/assets/homepage/prof.webp";
import PatternIizenglishHomeAvantages from "@/assets/homepage/pattern-iizenglish-home-avantages.webp";
import PatternIizenglishHomeMultisupport from "@/assets/homepage/pattern-iizenglish-home-multisupport.webp";
import StaticPagesHeader from "@/components/staticpages/StaticPagesHeader";
import DecoratedSubtitle from "@/components/staticpages/DecoratedSubtitle";
import StyledParagraph from "@/components/staticpages/StyledParagraph";

export default {
  name: "AboutIizenglish",
  components: {
    StaticPagesHeader,
    DecoratedSubtitle,
    StyledParagraph,
  },
  data() {
    return {
      originBackground: `url(${FormePlaneteIizenglishRose})`,
      studentScreen: {
        fr: StudentInscriptionFr,
        en: StudentInscriptionEn,
      },
      exerciceScreen: {
        fr: StudentExercicesFr,
        en: StudentExercicesEn,
      },
      paymentScreen: {
        fr: SubscribeFr,
        en: SubscribeEn,
      },
      teacherScreen: {
        fr: TeacherInscriptionFr,
        en: TeacherInscriptionEn,
      },
      teacherDashboardScreen: {
        fr: TeacherSpaceFr,
        en: TeacherSpaceEn,
      },
      studentIcon: StudentIcon,
      teacherIcon: TeacherIcon,
      bottomBackground: `url(${PatternIizenglishHomeAvantages})`,
      patternIizenglish: `url(${PatternIizenglishHomeMultisupport})`,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$store.dispatch("users/getLocalization");
  },
  computed: {
    contentSection: function () {
      const contentSectionParagraphs = [
        [
          this.$t(`about.contentSection.paragraphs[0][0]`),
          this.$t(`about.contentSection.paragraphs[0][1]`),
          this.$t(`about.contentSection.paragraphs[0][2]`),
          this.$t(`about.contentSection.paragraphs[0][3]`),
        ],
        this.$t("about.contentSection.paragraphs[1]"),
      ];

      return contentSectionParagraphs;
    },
    price() {
      let subscriptionPrice =
        this.$store.getters["users/getCountry"].subscription_price;
      const currency = this.$store.getters["users/getCountry"].currency;
      if (subscriptionPrice != null) {
        subscriptionPrice = subscriptionPrice.toLocaleString(
          this.$i18n.locale,
          { minimumFractionDigits: 2 },
        );
      }
      // TODO: Fix => this.$n doesn't work for numberFormats !
      const displayPrice =
        this.$i18n.locale === "en"
          ? `${currency}${subscriptionPrice}`
          : `${subscriptionPrice}${currency}`;
      return displayPrice;
    },
  },
};
</script>

<style scoped lang="scss">
.about-container {
  .app-content {
    background-position: center left;
    background-repeat: no-repeat;
    background-size: 39% auto;
    background-color: $whiteColor;
    box-shadow: inset 0 0 0 1000px rgba(255, 255, 255, 0.8);
  }

  .styled-content {
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-color: $whiteColor;
    box-shadow: inset 0 0 0 1000px rgba(255, 255, 255, 0.8);
    margin-bottom: 2rem;
  }

  .title {
    text-align: center;
    font-family: "Averia Sans Libre", sans-serif;
    font-size: 3em;
    color: $primaryColor;
    margin: 40px 0 40px 0px;
  }

  .subtitle {
    font-family: "Averia Sans Libre", sans-serif;
    font-size: 2em;
    color: $primaryColor;
    margin: 20px 0 20px 0px;
  }

  .image {
    max-width: 100%;
    border: 0.15rem solid #c3c3c3;
    border-radius: 34px 34px 34px 34px;
  }

  .side-text {
    margin-top: auto;
    margin-bottom: auto;
    padding: 2em;
  }

  .icon {
    width: auto;
    margin-top: auto;
    margin-bottom: auto;
    margin-left: auto;
    margin-right: auto;
  }

  .pill {
    margin: 0px 5px 0px 5px;
    display: flex;
    align-items: center;
    border: 3px solid $tertiaryBorderColor;
    background-color: $tertiaryColor;
    padding: 10px 10px 10px 10px;
    height: 40px;
    border-radius: 20px;
    color: inherit;
    text-decoration: inherit;
    padding: 1rem 1.25rem;
    width: 30em;
    margin-bottom: 1rem;

    &:hover {
      cursor: pointer;
      background-color: $secondaryColor;
    }
  }

  .bottom-section {
    background-color: $primaryColorLight;
    box-shadow: inset 0 0 0 1000px rgba(185, 206, 234, 0.8);
    background-position: bottom left;
    background-size: cover;
    padding: 50px 0px 50px 0px;
    width: 100%;

    .content {
      background-color: $whiteColor;
      border-radius: 3em 3em 3em 3em;
      padding: 3em 2em 3em 2em;
      margin: 2em;

      .section-title {
        text-align: center;
        font-family: "Averia Sans Libre", sans-serif;
        font-size: 2em;
        color: $primaryColor;
        padding-bottom: 1em;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .icon {
      display: none;
    }
  }
}
</style>
